import { connect } from 'react-redux';
import { statusesLoadingSelector } from '../redux/selectors';
import DashboardButton from '../components/DashboardButton';

const mapStateToProps = state => ({
  isLoading: statusesLoadingSelector(state),
});

export default connect(mapStateToProps)(DashboardButton);
